// routes/_app.train-lora.tsx
import CSREntry from 'src/clientRoutes/_app.train-lora.csr'
import FullSSREntry from 'src/clientRoutes/_app.train-lora.full-ssr'
import { FeatureFlags } from 'src/experiments/featureFlags'
import { dynamicWithFeatureFlag } from 'src/experiments/featureFlags/dynamicWithFeatureFlag'
import { getI18n } from 'src/i18n/i18n.middleware'
import { SSR_DUAL_MODE_EXPERIMENT } from 'src/utils/router/ssrShell'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.train-lora'

export const handle = {
  name: 'train-lora',
  track: { scene: 'train-lora' },
  ssrShell: true,
  // Gate the SSR-shell branch behind the global Stage 2 dual-mode
  // experiment so the route can serve both the legacy CSR path
  // (control) and the Full SSR path (treatment) from the same code
  // base. See `src/utils/router/ssrShell.ts`.
  ssrShellExperiment: SSR_DUAL_MODE_EXPERIMENT,
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('common:meta.title.train-lora'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

/**
 * Opt out of a `HydrateFallback`. The train-lora route renders the real
 * page tree both on the server and the client, so React Router never has
 * to interpose a shell between the SSR HTML and the hydrated output.
 */
export function HydrateFallback() {
  return null
}

/**
 * Dual-mode entry. `'off'` (CSR) path renders `TrainLoraPage`
 * directly under `<RootRuntime>`'s global Apollo / QueryClient with
 * no SSR seed; `'on'` (Full SSR) path mounts the route-scoped
 * empty Apollo bridge from `clientRoutes/_app.train-lora.full-ssr.tsx`.
 */
export default dynamicWithFeatureFlag({
  flagName: FeatureFlags.SsrDualMode,
  off: () => <CSREntry />,
  on: () => <FullSSREntry />,
})
